
/* eslint-disable @typescript-eslint/no-this-alias, prefer-rest-params, no-useless-escape, @typescript-eslint/no-explicit-any */
import { defineComponent } from "vue";
import { v1 as uuidV1 } from "uuid";
function generateGuid() {
  return uuidV1();
}
export default defineComponent({
  props: {
    src: {
      type: String,
      required: true,
    },
    crossorigin: {
      type: String,
      required: false,
      default: "anonymous",
    },
    target: {
      type: String,
      required: false,
      default: "_parent",
    },
    className: {
      type: String,
      required: false,
      default: "",
    },
    allow: {
      type: String,
      required: false,
      default: "",
    },
    name: {
      type: String,
      required: false,
      default: "",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    sandbox: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      iframeEl: null as null | HTMLIFrameElement,
      iframeLoadedMessage: `IFRAME_LOADED_${generateGuid()}` as string,
      iframeOnReadyStateChangeMessage:
        `IFRAME_ON_READ_STATE_CHANGE_${generateGuid()}` as string,
    };
  },
  emits: ["iframe-load", "load"],
  watch: {
    src() {
      //        this.reinitIframe();
    },
  },
  methods: {
    removeIframe() {
      while (this.$el.firstChild) {
        this.$el.removeChild(this.$el.firstChild);
      }
    },
    setIframeUrl() {
      if (this.iframeEl === null || this.iframeEl.contentWindow === null) {
        setTimeout(this.setIframeUrl);
        return;
      }
      const iframeDoc = this.iframeEl.contentWindow.document;
      iframeDoc.open().write(
        `<body onload="window.location.replace('${this.src}');
          parent.postMessage('${this.iframeLoadedMessage}', '*')"></body>
          <script> window.document.onreadystatechange = function () { if
          (window.document.readyState === 'complete') {
          parent.postMessage('${this.iframeOnReadyStateChangeMessage}', '*') }
          }; <\/script> `
      );
      iframeDoc.close(); //iframe onload event happens
    },
    reinitIframe() {
      this.removeIframe();
      this.initIframe();
    },
    initIframe() {
      this.iframeEl = document.createElement("iframe");
      this.iframeEl.setAttribute(
        "style",
        "visibility: hidden; position: absolute; top: -99999px; border: none;"
      );
      if (this.src) this.iframeEl.setAttribute("iframe-src", this.src);
      if (this.className) this.iframeEl.setAttribute("class", this.className);
      //if (this.class) this.iframeEl.setAttribute('class', this.class);
      if (this.crossorigin)
        this.iframeEl.setAttribute("crossorigin", this.crossorigin);
      if (this.target) this.iframeEl.setAttribute("target", this.target);
      if (this.allow) this.iframeEl.setAttribute("allow", this.allow);
      if (this.name) this.iframeEl.setAttribute("name", this.name);
      if (this.title) this.iframeEl.setAttribute("title", this.title);
      if (this.sandbox) this.iframeEl.setAttribute("sandbox", this.sandbox);
      this.$el.appendChild(this.iframeEl);
      this.setIframeUrl();
    },
    listenForEvents() {
      // Create IE + others compatible event handler
      const eventMethod = "addEventListener";
      const eventer: any = window[eventMethod as any];
      const messageEvent = "message";
      // Listen to message from child window
      eventer(messageEvent, this.messageEventListener, false);
    },
    messageEventListener(event: any) {
      if (event.data === this.iframeLoadedMessage) {
        this.$emit("iframe-load");
        if (this.iframeEl)
          this.iframeEl.setAttribute(
            "style",
            "visibility: visible; border: none;"
          );
      }
      if (event.data === this.iframeOnReadyStateChangeMessage) {
        this.$emit("load");
      }
    },
  },
  mounted() {
    this.listenForEvents();
    this.initIframe();
  },
  unmounted() {
    window.removeEventListener("message", this.messageEventListener);
  },
});
